import { render, staticRenderFns } from "./AdminAffiliates.vue?vue&type=template&id=0b184b36&scoped=true"
import script from "./AdminAffiliates.vue?vue&type=script&lang=js"
export * from "./AdminAffiliates.vue?vue&type=script&lang=js"
import style0 from "./AdminAffiliates.vue?vue&type=style&index=0&id=0b184b36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b184b36",
  null
  
)

export default component.exports